import { Calculator, Cloud, FileCode, Globe, Search, Terminal } from "lucide-react";

const CAPABILITIES = [
	{
		icon: Search,
		label: "Web Search",
		description: "Search DuckDuckGo for current events and facts",
	},
	{
		icon: FileCode,
		label: "Code & Files",
		description: "Read, write, and manage files in your workspace",
	},
	{ icon: Globe, label: "Web Fetch", description: "Extract content from any webpage" },
	{ icon: Calculator, label: "Calculate", description: "Evaluate math expressions instantly" },
	{ icon: Cloud, label: "Weather", description: "Get real-time weather for any city" },
	{
		icon: Terminal,
		label: "Run Code",
		description: "Execute JavaScript in a sandboxed environment",
	},
];

const SUGGESTIONS = [
	"Search for the latest AI news",
	"Create a React component for a todo list",
	"What's the weather in Tokyo?",
	"Calculate 15% of $847.32",
	"Fetch and summarize https://example.com",
];

interface WelcomeScreenProps {
	onSuggestion: (text: string) => void;
}

export function WelcomeScreen({ onSuggestion }: WelcomeScreenProps) {
	return (
		<div className="flex flex-col items-center justify-center h-full px-4 py-8 overflow-y-auto">
			<div className="max-w-2xl w-full space-y-8">
				<div className="text-center space-y-3">
					<div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-primary/10 mb-2">
						<span className="text-2xl">🤖</span>
					</div>
					<h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Boring Agent</h1>
					<p className="text-muted-foreground text-sm sm:text-base max-w-md mx-auto">
						Your AI assistant running on Cloudflare's edge network. Search, code, calculate, and
						more.
					</p>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
					{CAPABILITIES.map(({ icon: Icon, label, description }) => (
						<div
							key={label}
							className="flex items-start gap-3 p-3 rounded-xl bg-card border border-border hover:border-primary/50 transition-colors"
						>
							<div className="p-2 rounded-lg bg-primary/10 shrink-0">
								<Icon className="w-4 h-4 text-primary" />
							</div>
							<div className="min-w-0">
								<p className="font-medium text-sm">{label}</p>
								<p className="text-xs text-muted-foreground mt-0.5">{description}</p>
							</div>
						</div>
					))}
				</div>

				<div className="space-y-3">
					<p className="text-xs font-medium text-muted-foreground uppercase tracking-wider text-center">
						Try asking
					</p>
					<div className="flex flex-wrap justify-center gap-2">
						{SUGGESTIONS.map((suggestion) => (
							<button
								key={suggestion}
								type="button"
								onClick={() => onSuggestion(suggestion)}
								className="px-3 py-1.5 text-xs sm:text-sm rounded-full bg-card border border-border hover:border-primary/50 hover:bg-primary/5 transition-all text-left"
							>
								{suggestion}
							</button>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
